export const config = {
  title: "AWV CONSTRUCTION | Custom Home Builders in San Francisco, CA",
  meta: {
    description:
      "AWV CONSTRUCTION specializes in custom home building and remodeling services in the San Francisco Bay Area. From kitchen upgrades to concrete finishing, we deliver quality craftsmanship tailored to your needs.",
    keywords: [
      "AWV CONSTRUCTION",
      "Custom Home Builders San Francisco",
      "Home Remodeling San Francisco",
      "Concrete Finishing",
      "Kitchen Renovation",
      "Bathroom Remodeling"
    ],
    author: "AWV CONSTRUCTION",
    canonicalUrl: "https://worldvtechconstruction.com/"
  },
  sections: {
    header: {
      businessName: "AWV CONSTRUCTION"
    },
    sectionB: {
      heroTitle: "Building Your Dream Home with Precision and Care",
      heroSubtitle: "Expert Custom Home Builders in the San Francisco Bay Area",
      learnAboutText: "Discover Our Services",
      phoneNumber: "4154992658",
      phoneLabel: "(415) 499-2658",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1171642458/photo/roofer-worker-in-protective-uniform-wear-and-gloves.jpg?s=612x612&w=0&k=20&c=g4gdkeIRGClSGdAtbeBUPSblJgoOwz81fpYWPQ5ll3E=",
      cardData: [
        {
          title: "Custom Home Building",
          description:
            "From foundation to finish, we craft homes that reflect your vision and lifestyle."
        },
        {
          title: "Home Remodeling",
          description:
            "Transform your existing space with our comprehensive remodeling services."
        },
        {
          title: "Concrete Services",
          description:
            "Expert concrete finishing, formwork, and reinforcement for durable structures."
        }
      ],
      description:
        "At AWV CONSTRUCTION, we are committed to delivering top-quality construction services, ensuring each project meets our clients' unique needs and expectations."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive construction solutions tailored to your needs.",
      cards: [
        {
          title: "Custom Home Building",
          description:
            "We specialize in building custom homes that combine functionality with aesthetic appeal.",
          imageSrc: "https://worldvtechconstruction.com/wp-content/uploads/2024/02/Layer-19.png",
          imageAlt: "Custom Home Building"
        },
        {
          title: "Home Remodeling",
          description:
            "Our remodeling services cover kitchens, bathrooms, living rooms, and basements.",
          imageSrc: "https://worldvtechconstruction.com/wp-content/uploads/2024/03/646816820008-1.jpg",
          imageAlt: "Home Remodeling"
        },
        {
          title: "Concrete Services",
          description:
            "We provide concrete finishing, formwork, and reinforcement services for various projects.",
          imageSrc: "https://worldvtechconstruction.com/wp-content/uploads/2024/03/WDV-US-21022024-55426175231-1-1024x768.jpg",
          imageAlt: "Concrete Services"
        }
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Kitchen Renovation",
        "Bathroom Remodeling",
        "Basement Finishing",
        "Living Room Upgrades",
        "General Contracting"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://worldvtechconstruction.com/wp-content/uploads/2024/03/KA-FF-WDV-US-21022024-55426175231-World-Vtech-Construction-01-1-768x305.jpg",
        alt: "AWV CONSTRUCTION Team"
      },
      aboutText: [
        "AWV CONSTRUCTION is a San Francisco-based construction company dedicated to providing exceptional custom home building and remodeling services.",
        "Our team of experienced professionals ensures each project is completed with precision, transforming your space into a place you'll love."
      ]
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: "AWV CONSTRUCTION Logo",
      businessName: "AWV CONSTRUCTION",
      contact: {
        phone: "4154992658",
        phoneLabel: "(415) 499-2658",
        email: "info@worldvtech.com",
        website: "https://worldvtechconstruction.com/",
        address: "850 South Van Ness Ave Suite 2, San Francisco, CA 94110"
      },
      socialMedia: {
        facebook: null,
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null // Add YouTube URL if available
      }
    },
    sectionF: {
      address: "850 South Van Ness Ave Suite 2, San Francisco, CA 94110",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.123456789!2d-122.419415!3d37.774929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7e2b1234567%3A0x123456789abcdef!2s850%20South%20Van%20Ness%20Ave%20Suite%202%2C%20San%20Francisco%2C%20CA%2094110!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus"
    }
  }
};

export default config;
